import React from 'react';
import { ButtonRectangleRadioGroup } from '@yme/atoms/button-select';
import { useTranslation } from '@yme/services/i18n';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3, RegularTextLevel4 } from '@yme/tokens/typography';
import { SCOOTERS_PRODUCT_OPTION_DATA_TEST_ID, useCommonProductOptions } from '../productOptions';
export function SelectScootersOptions({ productFilterOptions, variantsOfProduct, isMobileView, }) {
    const { onSelectNewValue, possibleOptions, allVariants, productOption, isProductOptionsFilterExist, } = useCommonProductOptions({
        productFilterOptions,
        variantsOfProduct,
        isRadioButtons: true,
        isMasterVariationSorting: true,
    });
    const { t } = useTranslation();
    if (isProductOptionsFilterExist) {
        return (React.createElement(FlexWrapper, { mt: "20px", flexDirection: "column" },
            React.createElement(FlexWrapper, { mb: "8px" },
                React.createElement(RegularTextLevel3, { weight: 500 }, t('productCard_version_label'))),
            React.createElement(FlexWrapper, { flexDirection: isMobileView ? 'column' : 'row', gap: "12px" },
                React.createElement(ButtonRectangleRadioGroup, { contentTag: RegularTextLevel4, setActiveOption: onSelectNewValue, allOptions: allVariants, possibleOptions: possibleOptions, selectedValue: productOption, dataTestId: SCOOTERS_PRODUCT_OPTION_DATA_TEST_ID, isRadioVisible: true }))));
    }
    return null;
}
